/** 海运分享管理及预览界面的zh-CN文案。 */
export default {
  auto: {
    tab: '自动分享',
    create: '新建自动分享任务',
    edit: '编辑任务',
    detail: '任务详情',
    code: '任务编码',
    generated: '保存后自动生成',
    enabled: '任务状态',
    on: '启用',
    off: '暂停',
    scheduleEnabled: '每日定时',
    dailyTime: '每日执行时间',
    zoneId: '业务时区',
    scope: '分享范围',
    save: '保存',
    saved: '任务设置已保存',
    pricePolicy:
      '自动分享和手动分享一样：先加商务价，再按分享目标加销售价。没命中销售规则的运价会跳过。范围留空表示当前权限内全部有效运价。',
    selectionRequired: '请至少选择一种业务类型和一个分享目标',
    masterSwitch: '自动分享总开关',
    masterOff: '自动分享总开关已关闭，任务不会继续执行，已分享运价保留。',
    masterConfirm: '确认修改自动分享总开关？关闭将停止后续自动处理，已分享运价保留。',
    manualOnly: '仅手动执行',
    lastRun: '最近执行（UTC）',
    progress: '查看执行结果',
    history: '执行历史',
    run: '立即执行',
    runConfirm:
      '确认按当前任务范围执行分享？系统将使用当前真实价格，结果可在分享列表和执行进度中查看。',
    pause: '暂停',
    resume: '启用',
    delete: '删除',
    deleteConfirm: '确认删除任务？任务将不再执行，已分享运价保留。'
  },
  data: {
    matchFailed: '基础资料匹配失败，请查看缺项明细。',
    invalid: '基础资料引用或目标身份不正确。',
    serviceUnavailable: '暂时无法查询基础资料，请稍后重试。',
    tooMany: '运价涉及的基础资料超过单次处理容量。',
    issue: '{type}「{source}」：{reason}',
    issueDetails: '查看资料匹配明细',
    unknownType: '基础资料',
    unnamed: '未识别资料',
    summary: {
      missing: '接收方未找到可用的{type}「{names}」',
      sourceMissing: '来源方未找到可用的{type}「{names}」',
      unavailable: '来源方的{type}「{names}」或其引用已停用、不可用',
      ambiguous: '{type}「{names}」存在多个对应项，无法唯一匹配',
      identityMissing: '{type}「{names}」缺少匹配代码或完整层级',
      unknown: '{type}「{names}」匹配失败，请查看明细',
      separator: '；'
    },
    reasons: {
      missing: '接收方没有可用的对应资料或未启用引用',
      ambiguous: '接收方有多个对应项，无法唯一匹配',
      unavailable: '资料或引用已停用',
      sourceMissing: '无法读取来源资料',
      identityMissing: '缺少可靠匹配代码或完整层级'
    },
    types: {
      SEAPORT: '港口',
      AIRPORT: '机场',
      RAILWAY_STATION: '铁路站点',
      ROUTE: '航线',
      CARRIER: '承运人',
      FEE: '费用项目',
      BILLING_UNIT: '计费单位',
      CURRENCY: '币种',
      CONTAINER_TYPE: '箱型',
      TRANSPORT_TERM: '运输条款',
      TRADE_TERM: '贸易条款',
      CARGO_TYPE: '货物类型',
      COUNTRY: '国家',
      DIVISION: '行政区划',
      TERMINAL: '码头',
      WAREHOUSE: '仓库'
    }
  },
  sync: {
    status: '同步状态',
    current: '已同步',
    running: '同步中',
    failed: '同步失败',
    paused: '已冻结',
    sourceStopped: '来源已失效',
    retry: '重试同步',
    lastSyncedAt: '最后同步时间：{time}',
    readOnly: '收到的运价由来源方维护，当前仅可查看。'
  },
  management: {
    myJobs: '我的执行记录',
    total: '总项数',
    success: '成功',
    failed: '失败',
    action: { CANCEL: '取消分享', RETRY: '重试分享', AUTO: '自动分享' },
    progress: '分享执行进度',
    loadFailed: '读取失败，请刷新重试',
    counts: '共{total}项，成功{success}项，失败{failed}项',
    recordId: '分享执行ID',
    allMatched: '选择当前筛选结果全部{total}条',
    bulkCancel: '批量取消分享',
    bulkRetry: '批量重试',
    confirm: '确认批量操作',
    confirmCount: '确认处理选中的{count}条分享记录？操作会分别处理并保留每条结果。',
    errors: {
      stopped: '自动分享已停止，已分享的运价保留。',
      tooMany: '筛选结果超过单次任务容量，请缩小分享范围后重试。',
      busy: '任务正在执行或设置已变化，请刷新后重试。',
      notFound: '任务或执行记录不存在，或您没有访问权限。',
      invalid: '分享管理参数不正确，请检查筛选条件或任务设置。'
    },
    states: {
      '1': '待处理',
      '2': '处理中',
      '3': '成功',
      '4': '失败',
      '5': '已停止'
    }
  },
  filters: {
    loadingAddress: '装货地址',
    addressLoadFailed: '地址加载失败，请重新展开重试',
    routeType: '铁路线路分类',
    loadingPort: '装货港',
    loadingStation: '装货站',
    destinationPort: '目的港',
    destinationStation: '目的站',
    sourceCity: '起运城市（主数据城市名称）',
    targetCity: '目的城市（主数据城市名称）',
    targetRoute: '目的航线',
    more: '更多筛选',
    less: '收起筛选',
    unlimited: '不限',
    sharedBy: '分享人',
    sharedFrom: '分享开始时间',
    sharedTo: '分享结束时间',
    failedFrom: '失败开始时间',
    failedTo: '失败结束时间',
    originCountry: '发货国家',
    originProvince: '发货省州',
    originCity: '发货城市',
    originDistrict: '发货区县',
    destCountry: '目的国家',
    destProvince: '目的省州',
    destCity: '目的城市',
    destDistrict: '目的区县',
    serviceType: '服务类型',
    direct: {
      '1': '直达',
      '2': '中转',
      '3': '不指定'
    },
    service: {
      express: '特快',
      standard: '标快',
      economy: '经济',
      priority_freight: '优先货运',
      economy_freight: '经济货运',
      deferred_freight: '递延货运'
    }
  },
  sourceNotIntegrated: '滚装、散杂的超级运价维护源尚未接入，暂不支持新建分享。',
  partners: '伙伴企业',
  partnerSearch: '搜索伙伴名称或编码',
  selectPartner: '选择伙伴企业',
  loadMorePartners: '加载更多伙伴',
  partnerDisabled: '该客商未开通运价分享',
  partnerRoleIneligible: '需同时具备客户和供应商角色',
  partnerUnbound: '未匹配唯一正常接收企业',
  partnerResultCount: '共{count}家客商',
  partnerLoadFailed: '伙伴状态读取失败，请重试',
  targetSubmitFailed: '以下目标未能完成提交，请重试：{targets}。已受理目标会复用原结果。',
  targetPreviewFailed: '以下目标预览失败，已标为不可提交：{targets}。其他可用目标仍可确认分享。',
  libraryReadOnly: '此运价已保存到本企业运价库，来自伙伴分享，只读查看。',
  sourcePriceNo: '来源运价编码',
  libraryStates: { active: '有效', revoked: '已撤回', expired: '已过期' },
  loadMode: '装载模式',
  flightNo: '航班号',
  railTrainNo: '班列号',
  voyageDays: '运输天数',
  voyageHours: '运输小时',
  minBillingWeight: '最低计费重量（KG）',
  volumetricFactor: '体积重系数',
  vehicleType: '车种',
  departureTime: '出发时间',
  arrivalTime: '到达时间',
  billingMethod: '计费方式',
  conditionalFee: '按所选作业项目计入',
  billingMethods: {
    AIR_TICKET: '按票',
    AIR_CHARGE_WEIGHT: '计重（KG）',
    AIR_ACTUAL_WEIGHT: '实重（KG）',
    WEIGHT: '按重量',
    VOLUME: '按体积',
    WEIGHT_VOLUME_MAX: '重量体积取大',
    PIECE: '按件',
    TICKET: '按票',
    TRIP: '按趟',
    KM: '按公里'
  },
  loadModes: { EXPRESS: '快递', LTL: '零担', FTL: '整车' },
  preport: '港前',
  lastmile: '尾程',
  air: '空运',
  express: '快递',
  rail: '铁路',
  originNode: '起运节点',
  destinationNode: '目的节点',
  startAddress: '起运地址',
  destinationAddress: '目的地址',
  unloadPlace: '卸货地',
  airline: '航空公司',
  railCompany: '铁路公司',
  expressCompany: '快递公司',
  supplier: '供应商',
  originAirport: '起运机场',
  destinationAirport: '目的机场',
  originStation: '起运站',
  destinationStation: '目的站',
  cargoType: '货物类型',
  transferAirports: '中转机场',
  exitPort: '出境口岸',
  entryPort: '入境口岸',
  transitStations: '中转站',
  transportMode: '运输方式',
  billingModel: '计费模式',
  priceAxis: '计价分量/区间',
  priceTable: '计费价表',
  viewPriceTable: '查看价表',
  priceItemCount: '{count}项计费',
  density: '密度档',
  step: '计费步长',
  stdWeight: '标重',
  minKm: '最低公里数',
  variant: '计价组合',
  validFrom: '有效期起',
  components: {
    PICKUP: '提货费',
    DELIVERY: '派送费',
    LOADING: '装卸费',
    UNIT: '单价',
    AIR_TIER: '空运重量档',
    FIRST_WEIGHT: '首重价',
    ADDITIONAL_WEIGHT: '续重价',
    WEIGHT_TIER: '重量区间价',
    WEIGHT_TIER_TOTAL: '重量段总价',
    TRIP: '趟价',
    KM: '公里价',
    ONE_PRICE: '一口价',
    BASE_PRICE_1: '基础价一',
    BASE_PRICE_2: '基础价二',
    VOLUME_TIER: '体积档',
    PERCENTAGE: '比例费用'
  },
  billingModels: { FIRST_ADDITIONAL: '首重续重', UNIT_PRICE: '单价', WEIGHT_TIER: '重量段' },
  transportModes: {
    '1': '公路',
    '2': '驳船',
    '3': '铁路',
    集装箱: '集装箱',
    container: '集装箱',
    CONTAINER: '集装箱',
    FCL: '集装箱',
    整箱: '集装箱',
    整车: '整车',
    truck: '整车',
    FTL: '整车',
    散货: '散货',
    bulk: '散货',
    LTL: '散货',
    LCL: '散货'
  },

  title: '运价分享',
  presetCount: '已预选{count}条来自运价维护的运价，可继续选择。',
  shareSelected: '分享所选运价',
  submitAccepted: '分享已受理',
  viewResults: '源运价保持不变，可到运价分享页面查看真实发布结果。',
  viewResultsAction: '查看分享结果',
  plazaTitle: '运价广场',
  scope: '选择可用运价，预览分享至沃行之家的完整销售价格。',
  open: '新建分享',
  selectTitle: '新建分享 — 选择已上架运价',
  previewTitle: '新建分享 — 确认分享价格',
  platform: '分享平台',
  selectTarget: '请至少选择一个分享目标。',
  businessType: '业务类型',
  shareTarget: '分享目标',
  shelfStatus: '上架状态',
  published: '已上架',
  priceBasis: '价格口径',
  footerSummary: '已选 {count} 条（跨页、跨类型保留）｜目标 {targets} 个',
  previewSummary: '勾选运价数量：{selected} 条；可预览：{ready} 条',
  candidateFailed: '候选查询失败，请根据错误提示检查权限或服务状态后重试。',
  previewFailed: '价格预览失败，请根据错误提示重试。',
  retryQuery: '查询未完成，请重试',
  noCandidates: '暂无符合筛选条件的可分享运价',
  noPreview: '暂无可预览的价格记录',
  selectStep: '选择运价',
  previewStep: '价格预览',
  pricePolicy:
    '先加商务价，再按分享目标加销售价。沃行之家用沃行之家渠道，伙伴用 CargoWareX 渠道；没命中销售规则就不分享，零加价规则可以分享。',
  searchPlaceholder: '运价编码',
  search: '查询',
  reset: '重置',
  refresh: '刷新候选',
  clearSelection: '清空选择',
  fcl: '海运整箱',
  lcl: '海运拼箱',
  roro: '滚装',
  bulk: '散杂货',
  chargeMode: '计价方式',
  byContainer: '按箱型',
  byUnit: '按单位',
  mixedCharge: '按箱型 / 按单位',
  available: '可用',
  family: '沃行之家',
  selected: '已选 {count} / {max} 条',
  priceNo: '运价编码',
  route: '路径',
  carrier: '船公司',
  por: '收货地',
  pol: '起运港',
  pod: '卸货港',
  pdl: '目的港',
  directTransit: '直达/中转',
  transferPorts: '中转港',
  vessel: '船名',
  voyage: '航次',
  laneCode: '航线代码',
  validTo: '有效期至',
  office: '所属公司',
  validity: '有效期',
  noSalesRule: '没匹配到该渠道的有效销售规则，不能分享',
  previewStatus: '预览状态',
  salesPrice: '商务卖价',
  sharePrice: '最终分享价',
  status: {
    READY: '可预览',
    UNAVAILABLE: '源运价不可用或无权访问',
    NO_PRICE: '缺少基础报价',
    INVALID_PRICE: '价格或计费信息异常'
  },
  feeType: '费用归属',
  feeTypes: {
    '1': '主干运费',
    '2': '起运港费用',
    '3': '目的港费用',
    '4': '其他费用'
  },
  origin: '价格来源',
  origins: {
    BASE_FREIGHT: '基础运费',
    SOURCE_FEE: '源运价费用',
    SURCHARGE: '匹配附加费'
  },
  feeName: '费用名称',
  baseFreight: '基础运费',
  unit: '箱型 / 计费单位',
  currency: '币种',
  minCharge: '最低收费',
  maxCharge: '最高收费',
  totalIncluded: '已含总价',
  countTotal: '计入总价',
  yes: '是',
  no: '否',
  empty: '—',
  routeSeparator: '→',
  previewOnly: '价格预览已生成，本阶段仅提供预览，实际发布将在后续阶段接入。',
  unavailableNotice: '不可分享的运价已标明原因，确认时只提交可分享的运价。',
  close: '关闭',
  back: '上一步',
  next: '下一步',
  refreshPreview: '刷新价格预览',
  selectionLimit: '单次最多选择 {max} 条运价。',
  confirmHint: '确认后发布至沃行之家；不可用记录不提交。',
  confirmShare: '确认分享',
  confirmChanged: '预览或目标已变化，请重新查看价格后确认。',
  confirmContent: '确认将{count}条运价按预览价格发布至沃行之家？另有{skipped}条不可用记录不提交。',
  cancel: '取消',
  confirm: '确定',
  submitResult: '分享结果：成功{succeeded}条，失败{failed}条，待处理{pending}条。',
  shareCode: '分享编码',
  copyCode: '点击复制分享编码',
  copied: '分享编码已复制。',
  copyFailed: '浏览器无法复制，请手动选择分享编码。',
  publicRateId: 'Family运价ID',
  shareTime: '分享时间',
  publicationState: '公开状态',
  active: '有效',
  inactive: '已取消或替代',
  detail: '详情',
  detailView: {
    title: '分享记录 · 运价详情',
    failedTitle: '分享失败 · 运价详情',
    historyTitle: '历史快照 · 运价详情',
    successLabel: '成功分享',
    failedLabel: '失败分享',
    historyLabel: '历史快照',
    synced: '已同步',
    copyCode: '复制分享码',
    currentPrices: '本次分享价格',
    salesSnapshot: '销售卖价（快照）',
    shareSnapshot: '分享后价格（快照）',
    containerType: '柜型',
    sharingSnapshot: '分享快照',
    sharedBy: '分享人',
    lastSyncTime: '上次同步时间',
    rateInfo: '运价信息',
    basicInfo: '基本信息',
    spaceStatus: '舱位状态',
    priceTrend: '价格趋势',
    routeInfo: '航线信息',
    schedule: '船期',
    etd: 'ETD',
    eta: 'ETA',
    carrierInfo: '承运信息',
    contractNo: '合约号',
    nac: 'NAC',
    freeDays: '免费期限',
    detentionDays: '免箱期(天)',
    demurrageDays: '免堆期(天)',
    beginDate: '开始日期',
    endDate: '结束日期',
    notes: '备注',
    overweightNotes: '超重备注',
    receivingNotes: '收货须知',
    freightDetails: '运价费用明细',
    surchargeDetails: '附加费明细',
    billingUnit: '单位',
    unitPrice: '单价',
    containerUnit: '箱',
    listSeparator: '、'
  },
  cancelShare: '取消分享',
  cancelContent: '取消后该运价将从沃行之家下架，变更历史保留。确认取消分享？',
  retry: '重试',
  failureReason: '失败原因',
  actions: '操作',
  refreshRecords: '刷新结果',
  recordFailed: '分享结果查询失败，请根据错误提示重试。',
  noRecords: '暂无符合条件的分享记录',
  tabs: { success: '分享成功', failed: '分享失败', pending: '待处理', history: '变更历史' },
  errors: {
    invalidPrice: '当前计价结构无法完整同步，请检查来源运价后重试。',
    stale: '运价或价格已变化，请重新预览并再次分享。',
    sourceUnavailable: '源运价已失效或不可分享。',
    writeFailed: '发布失败，可重试。',
    supplierNotMatched: '接收方未匹配到唯一有效的供应商，请先维护供应商资料后重试。',
    replaced: '已被新分享或取消操作替代。',
    accessDenied: '当前已没有分享操作权限。',
    accessUnavailable: '暂时无法确认分享权限，请稍后重试。'
  }
}
